import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Row, Card, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { RUTA_MASCOTAS } from "../../../services/rutas";
import PetsIcon from "@mui/icons-material/Pets";
import {
  buscarMascotaParaMostrar,
  leerCertificadoVacuna,
  leerFoto,
  RespuestaBuscarMascotaParaMostrar as Mascota,
} from "../../../services/mascotasServicios";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadBlob } from "../../../utils/downloadUtils";
import { convertBase64ToBlob } from "../../../utils/blobUtils";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import NotFoundError from "../../../services/NotFoundError";
import Image from "react-bootstrap/Image";
import { RespuestaArchivo } from "../../../utils/fileUtils";

function CardSection() {
  let navigate = useNavigate();
  let { idMascota } = useParams();
  const [mascota, setMascota] = useState({} as Mascota);
  const [serverErrorOcurred, setServerErrorOcurred] = useState(false);
  const [foto, setFoto] = useState("");

  useEffect(() => {
    const _buscarMascota = async (id: string) => {
      const resp = await buscarMascotaParaMostrar(id);
      if (resp) {
        setMascota(resp);
      }
    };
    if (idMascota) {
      _buscarMascota(idMascota);
    }
  }, [idMascota]);

  useEffect(() => {
    const _leerFoto = async () => {
      if (mascota) {
        if (mascota.tieneFoto) {
          try {
            const respFoto = await leerFoto(mascota.id);
            if (respFoto) {
              setFoto(respFoto);
            }
          } catch (error: any) {
            if (!(error instanceof NotFoundError)) {
              setServerErrorOcurred(true);
            }
          }
        }
      }
    };
    _leerFoto();
  }, [mascota]);

  const onDescargarCertificadoClick = async () => {
    setServerErrorOcurred(false);
    if (idMascota) {
      let certificado: RespuestaArchivo | undefined | null;
      try {
        certificado = await leerCertificadoVacuna(idMascota);
      } catch (error: any) {
        setServerErrorOcurred(true);
      }
      if (certificado) {
        const content = certificado.contenido;
        const contenidoBlob = convertBase64ToBlob(
          content,
          certificado.extension || "application/pdf"
        );
        downloadBlob(contenidoBlob, certificado.nombre || "certificado.pdf");
      }
    }
  };

  const onEditarClick = () => {
    navigate(`${RUTA_MASCOTAS}/${idMascota}/editar`, { replace: false });
  };

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-10 col-lg-8 col-xxl-5">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mt-5 mb-4">
              <Col className="d-flex col-10 justify-content-center">
                {foto && (
                  <StyledAvatar
                    src={foto}
                    className="border border-3 border-primary"
                  />
                )}
                {!foto && (
                  <IconContainer>
                    <PetsIcon sx={{ fontSize: 100 }} />
                  </IconContainer>
                )}
              </Col>
            </Row>
            <Row className="justify-content-center mb-3">
              <Col>
                <Row>
                  <CardTitle className="text-center">
                    {mascota.nombre}
                  </CardTitle>
                </Row>
                <Row>
                  <ButtonsCol className="mt-4 d-flex justify-content-center">
                    <Button
                      id="buttonEditar"
                      type="button"
                      variant="primary"
                      onClick={onEditarClick}
                    >
                      <EditIcon sx={{ fontSize: 20 }} /> Editar
                    </Button>
                  </ButtonsCol>
                </Row>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col className="col-10">
                <h5 className="mb-4 mt-5">Datos Básicos</h5>
                <InfoRow
                  label="Propietario"
                  value={mascota.nombresPropietario}
                />
                <InfoRow label="Raza" value={mascota?.raza?.nombre} />
                <InfoRow label="Sexo" value={mascota?.sexo?.toString()} />
                <InfoRow label="Fecha Ingreso" value={mascota.fechaIngreso} />

                <h5 className="mb-4 mt-5">Información Médica</h5>
                <InfoRow
                  label="Esterilizada"
                  value={mascota.estaEsterilizada ? "Si" : "No"}
                />
                <InfoRow
                  label="Tiene Condición Médica"
                  value={mascota.tieneCondicionMedica ? "Si" : "No"}
                />
                <InfoRowParagraph
                  label="Observaciones Médicas"
                  value={mascota.observacionesMedicas}
                />
                <InfoRow
                  label="Temperamento"
                  value={mascota?.temperamento?.toString()}
                />
                <InfoRowParagraph
                  label="Observaciones Temperamento"
                  value={mascota.observacionesTemperamento}
                />
                <InfoRow
                  label="Último Garrapaticida"
                  value={mascota.mesesUltimoGarrapaticida}
                />
                <InfoRow
                  label="Periodicidad Garrapaticida"
                  value={mascota.mesesPeriodicidadGarrapaticida}
                />
                <InfoRow
                  label="Última Vacuna"
                  value={mascota.mesesUltimaVacuna}
                />
                <InfoRow
                  label="Nombre Veterinario"
                  value={mascota.nombreVeterinario}
                />

                <h5 className="mb-4 mt-5">Otras Observaciones</h5>
                <InfoRowParagraph
                  label="Observaciones Alimenticias"
                  value={mascota.observacionesAlimenticias}
                />
                <InfoRowParagraph
                  label="Comentarios Generales"
                  value={mascota.comentarios}
                />
              </Col>
            </Row>
            {mascota.tieneCertificadoVacuna && (
              <Row>
                <ButtonsCol className="mt-4 d-flex justify-content-center">
                  <Button
                    id="buttonEditar"
                    type="button"
                    variant="secondary"
                    onClick={onDescargarCertificadoClick}
                  >
                    <DownloadIcon sx={{ fontSize: 20 }} /> Certificado de Vacuna
                  </Button>
                </ButtonsCol>
              </Row>
            )}
            {serverErrorOcurred && <ServerErrorModal />}
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

interface InfoRowProps {
  label: string;
  value?: string;
}

function InfoRow({ label, value }: InfoRowProps) {
  return (
    <Row className="mb-2">
      <LabelCol className="col-6">{label + ":"}</LabelCol>
      <Col className="text-right">{value}</Col>
    </Row>
  );
}

function InfoRowParagraph({ label, value }: InfoRowProps) {
  return (
    <Row className="mb-2">
      <LabelCol className="col-6">{label + ":"}</LabelCol>
      <Col>
        <p>{value}</p>
      </Col>
    </Row>
  );
}

const StyledAvatar = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  width: 200px;
  height: 200px;
`;

const LabelCol = styled(Col)`
  font-weight: 500;
`;

const ButtonsCol = styled(Col)`
  gap: 1%;
`;

const CardTitle = styled("h3")`
  font-weight: 500;
  color: #454545;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  margin-bottom: 0px;
`;

const IconContainer = styled("span")`
  position: relative;
  margin-right: 10px;
  color: ${(props) => props.theme.colors.main};
  margin-left: 10px;
`;

export default CardSection;
